/************
 * List Tab Detail with right hand properties drawer
 * File Name ...: master-qualifications.component.ts
 * Generated By : ianday on 12/12/23
 * Date ........: 12/12/23
 /************/

import { Component, OnInit, ViewChild, HostListener, AfterContentInit } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Settings } from '../../../services/settings';
import { MasterQualification } from "../../../models/master-qualification";
import { QualificationService } from "../../../services/qualifications.service";
import { ValidationResult } from '../../../models/validation-result';
import { NotesComponent } from 'src/app/components/notes/notes.component';
import {
	ConfirmDialogComponent,
	ConfirmDialogModel
} from '../../../components/shared/confirmation-dialog/confirmation-dialog.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { TransactionHistoryService } from '../../../services/transactionhistory.service';
import { TransactionHistoryComponent } from '../../../components/transaction-history/transaction-history';
import { DwUtils } from '../../../components/utils/dw-utils';
import { RequesttypeMasterqualifyMappingComponent } from './drawer/requesttype-masterqualify-mapping/requesttype-masterqualify-mapping.component';

@Component({
	selector: 'app-master-qualifications',
	templateUrl: './master-qualifications.component.html',
	styleUrls: ['./master-qualifications.component.css']
})
export class MasterQualificationsComponent implements OnInit, AfterContentInit {

	/*** Header / Query Strip Variables ****/
	public formTitle = 'Master Qualifications';
	public pagination: string;

	/*** Editing variables ***/
	public isEditing: boolean | null = false;
	public isAdd: boolean | null = false;
	public records: any;
	public selectedRecord: MasterQualification;
	public historyRecord: MasterQualification;
	public Idx: number | null = -1;
	public strErr: string | null = '';
	public dataSource: MatTableDataSource<any>;

	public propContainerState: boolean | null = false;  /** set to false ***/
	public visiblePropertiesTab: boolean | null = true;
	public drawTabIndex: number | null = 0;


	public result: boolean | null = false;
	public disabledFlag: boolean | null = true;

	/**** Query strip filter settings ***/
	public selectedStatusFilter: string | null = 'Active';
	public contentClassWithBanner: string | null = 'dwtable-container';
	public contentClassWithoutBanner: string | null = 'dwtable-container-without-header';
	public contentClassName: string | null = 'dwtable-container';

	/*** Record Table / card table  ***/
	public displayedColumns: string[] = ['id', 'question', 'description', 'activeStatus'];

	/***** Control Strip Button Visibility ***/
	public visibleAdd: boolean | null = false;
	public visibleModify: boolean | null = false;
	public visibleDelete: boolean | null = false;
	public visibleRequestType: boolean | null = false;

	/***** Tab Detail Section *****/
	public selectedTabIndex: number | null = 0;

	public id: any | null = '';
	public valuseForAutomatch = 0;
	public valQuestion: any | null = '';
	public valDescription: any | null = '';
	public valActiveStatus: any | null = '';
	public valRequired = 0;

	public busyCursor: boolean = false;

	@ViewChild(MatSort, { static: true }) sort: MatSort;
	@ViewChild('history', { static: true }) history: TransactionHistoryComponent;
	@ViewChild('notes', { static: true }) notes: NotesComponent;
	@ViewChild('qualifymapping', { static: true }) qualifymapping: RequesttypeMasterqualifyMappingComponent;

	constructor(private qualificationsService: QualificationService,
		private txService: TransactionHistoryService,
		public dialog: MatDialog) {
		this.selectedRecord = new MasterQualification();
	}

	public ngOnInit() {
		if(Settings.getInstance().hasPrivilege("SETINGS_MASTER_QUALIFICATIONS", "WRITE")) {
			this.visibleAdd = true;
			this.visibleModify = true;
			this.visibleDelete = false;
		}
		if(Settings.getInstance().hasPrivilege("SETTINGS_MASTER_QUALIFICATION_REQUEST_TYPES", "READ")) {
			this.visibleRequestType = true;
		}
	}
	public ngAfterContentInit() {
		if (Settings.getInstance().enableMessageBanner) {
			this.contentClassName = this.contentClassWithBanner;
		} else {
			this.contentClassName = this.contentClassWithoutBanner;
		}

		this.queryRecords();
	}
	public queryRecords() {
		// Query records from the service
		this.busyCursor = true;
		this.qualificationsService.getAllMasterQualifications().subscribe(
			(result) => {
				this.busyCursor = false;
				this.records = result;

				this.dataSource = new MatTableDataSource(this.records);
				this.dataSource.sort = this.sort;
				this.setPagination(-1, this.dataSource.data.length);
				this.onChangeStatusFilterValue();
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Error: unable to retrieve master qualifications data from the service');
				this.busyCursor = false;
			}
		);
	}
	public setPagination(idx: number, total: number) {
		// Set pagination logic
		this.pagination = (idx + 1) + '/' + total;
	}
	public onChangeStatusFilterValue() {
		// Change status filter logic
		const dataTemp: MasterQualification[] = [];
		this.clearFilter();

		for (const rec of this.records) {
			if (rec.activeStatus === this.selectedStatusFilter || this.selectedStatusFilter === 'All') {
				dataTemp.push(rec);
			}
		}
		this.dataSource = new MatTableDataSource(dataTemp);
		this.setPagination(-1, this.dataSource.filteredData.length);
	}
	public onStatusChange() {
		// Status change logic
		this.qualificationsService.updateMasterQualification(this.selectedRecord).subscribe(
			() => {
				/*** add a transaction history record ***/
				const previousRecord = { ...this.selectedRecord };
				previousRecord.activeStatus = this.selectedRecord.activeStatus === "Active" ? "Inactive" : "Active";
				this.txService.updateTransactionHistory(previousRecord,
					this.selectedRecord, 'MasterQualifications', this.selectedRecord.id);
				this.onChangeStatusFilterValue();
			});
	}
	public doTabChange(): void {
		if(this.selectedTabIndex===1){
		this.history.onShowHandler('MasterQualifications', 'id', this.selectedRecord.id.toString(), this.selectedRecord.id.toString());
	}
	}
	@HostListener('matSortChange', ['$event'])
	public onSortChange(event: any) {

		if (event.direction === 'asc') {
			if (event.active === 'id') {
				this.records.sort((a, b) =>
					a[event.active] - (b[event.active]));
			}
			else {
				this.records.sort((a, b) =>
					a[event.active].localeCompare(b[event.active]));
			}
		} else {
			if (event.active === 'id') {
				this.records.sort((a, b) =>
					b[event.active] - (a[event.active]));
			}
			else {
				this.records.sort((a, b) =>
					b[event.active].localeCompare(a[event.active]));
			}
		}

		this.dataSource.data = this.records;
		this.onChangeStatusFilterValue();
		this.selectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}
	public clearFilter() {
		// Clear filter logic
		if (this.isEditing) {
			return;
		}
		this.unSelectRow();
		this.dataSource.filter = '';
		this.selectRow();
		this.setPagination(-1, this.dataSource.data.length);
	}
	public applyFilter(filterValue: string) {
		// Apply filter logic
		if (this.isEditing) {
			return;
		}
		this.dataSource.filter = filterValue.trim().toLowerCase();
		this.unSelectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}
	public selectRow() {
		// Select row logic
		if (this.selectedRecord.id === 0) {
			this.unSelectRow();
			return;
		}
		this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selectedRecord.id);
		this.setPagination(this.Idx, this.dataSource.data.length);
		this.displayDrawerData();
	}
	public unSelectRow() {
		// Unselect row logic
		this.Idx = -1;
		this.selectedRecord = new MasterQualification();
		this.setPagination(this.Idx, this.dataSource.data.length);
		this.displayDetail(this.selectedRecord);
	}
	public displayDetail(record: MasterQualification) {
		// Display detail logic
		if (record === undefined) {
			return;
		}
		this.id = record.id;
		this.valQuestion = record.question;
		this.valDescription = record.description;
		this.valActiveStatus = record.activeStatus;
		this.history.onShowHandler('MasterQualifications', 'id', record.id.toString());
	}
	public clear() {
		// Clear form logic
		this.id = '';
		this.valuseForAutomatch = 0;
		this.valQuestion = '';
		this.valDescription = '';
		this.valActiveStatus = '';
		this.valRequired = 0;
	}
	public addModifyRecord(isAdd: boolean) {
		// Add or modify record logic
		this.isAdd = isAdd;
		this.isEditing = true;
		this.selectedTabIndex = 0;

		if (this.isAdd) {
			this.clear();
			this.id = 0;
			this.valActiveStatus = 'Active';
		} else {
			// store the history record
			this.historyRecord = this.selectedRecord;
		}

		DwUtils.setFocus('description');
	}
	public removeRecord() {
		// Remove record logic
		const message = 'Remove Master Qualification: "' + this.selectedRecord.description + '" - Are you sure?';
		const dialogData = new ConfirmDialogModel('Please Confirm', message);

		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			width: '400px',
			data: dialogData,
			panelClass: 'custom-dialog-container'
		});

		dialogRef.afterClosed().subscribe(dialogResult => {
			this.result = dialogResult;
			if (this.result === true) {
				this.qualificationsService.deleteMasterQualification(this.selectedRecord.id).subscribe(
					() => {
						// remove the row from the table.
						this.records.splice(this.Idx, 1);
						this.dataSource.data = this.records;
						this.clear();
					},
					(error) => {
						Settings.getInstance().handleError(error);
					});
			}
		});
	}
	public validateFields(): boolean {
		// Validate fields logic
		this.strErr = '';
		const vr: ValidationResult = this.selectedRecord.validateRecord();

		if (vr.error.length > 0) {
			this.strErr = vr.error;
			DwUtils.setFocus(vr.focus_field);
			return false;
		}
		return true;
	}
	public submitRecord() {
		// Submit record logic
		this.selectedRecord = new MasterQualification();
		this.selectedRecord.id = this.id;
		this.selectedRecord.question = this.valQuestion;
		this.selectedRecord.description = this.valDescription;
		this.selectedRecord.activeStatus = this.valActiveStatus;

		this.strErr = '';

		if (!this.validateFields()) {
			return;
		}
		if (this.isAdd === true) {
			this.qualificationsService.createMasterQualification(this.selectedRecord).subscribe(
				(result) => {
					this.selectedRecord.id = result.id;
					this.isEditing = false;
					/*** add a transaction history record ***/
					this.txService.createTransactionHistory('MasterQualifications', this.selectedRecord.id);
				},
				() => {
					this.strErr = 'Error: The server could not add/submit this record';
					return;
				}
			);
		} else {

			this.qualificationsService.updateMasterQualification(this.selectedRecord).subscribe(
				() => {
					this.isEditing = false;
				},
				() => {
					this.strErr = 'Error: The server could not update this record';
					this.selectedRecord = this.historyRecord;
					return;
				});

			/*** add a transaction history record ***/
			this.txService.updateTransactionHistory(this.historyRecord,
				this.selectedRecord, 'MasterQualifications', this.selectedRecord.id);
		}
		this.updateSelectedRow();
	}
	public updateSelectedRow(): void {
		// Update the record in the table's data source - without refreshing it
		if (this.isAdd === true) {
			// add the new record to the top.
			this.records.unshift(this.selectedRecord);
			this.dataSource.data = this.records;
			this.onChangeStatusFilterValue();
			this.Idx = 0;
		} else {
			const i: number = this.records.findIndex(r => r.id === this.selectedRecord.id);
			this.Idx = i;
			this.records[i] = this.selectedRecord;
			this.dataSource.data = this.records;
			this.onChangeStatusFilterValue();
			this.selectRow();
			this.setPagination(this.Idx, this.dataSource.filteredData.length);
		}
		//this.dataSource.sort = this.sort;
	}
	public onRowClicked(selected: any) {
		// Row click logic
		if ((this.isEditing === true) || (this.qualifymapping.isEditing === true))
		{
			return;
		}

		this.selectedRecord = selected;
		this.selectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
		this.displayDetail(this.selectedRecord);
	}
	public tableKeyDown(event: KeyboardEvent) {

		if ((this.isEditing === true) || (this.qualifymapping.isEditing === true))
		{
			return;
		}

		const len: number = this.dataSource.filteredData.length;
		if (event.key === 'ArrowDown') {
			if (this.Idx < (len - 1)) {
				this.selectedRecord = this.dataSource.filteredData[++this.Idx];
				this.selectRow();
				this.displayDetail(this.selectedRecord);
			}
		} else if (event.key === 'ArrowUp') {
			if (this.Idx > 0) {
				this.selectedRecord = this.dataSource.filteredData[--this.Idx];
				this.selectRow();
				this.displayDetail(this.selectedRecord);
			}
		}
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}
	public cancelSubmitRecord() {
		// Cancel submit record logic
		this.strErr = '';
		this.isEditing = false;
		this.displayDetail(this.selectedRecord);
	}
	public onPropertiesToggle() {
		this.propContainerState = !this.propContainerState;
		/** if the drawer is open - then select the data for the selected record if chosen **/
		/*if ((this.propContainerState === true) && (this.selectedCaseId > 0)) {
			this.pastAssistance.onShowHandler(this.selectedCaseId);
		} */
	}
	public doDrawerTabChange(event: any): void {

		this.drawTabIndex = event.index;
		this.displayDrawerData();

	}
	public displayDrawerData(): void {

		/** Note there are one or two tabs not reflected here **.
		 * they were taken out temporarily
		 **/
		switch (this.drawTabIndex) {
			case 1:
				this.notes.parentId = this.selectedRecord.id;
				this.notes.onShowHandler();
				break;
			case 0:
				this.qualifymapping.onShowHandler(this.selectedRecord.id);
				break;
		}
	}
}
